import React, { useState } from "react";

const AddressBlock = ({ title, address }) => {
  // Defensive: ensure address is an object with all required keys
  if (!address || typeof address !== 'object' || Array.isArray(address)) {
    return (
      <div className="border rounded-lg p-4 w-full">
        <h5 className="font-bold mb-2">{title}</h5>
        <div className="text-sm text-gray-700">Address information unavailable</div>
      </div>
    );
  }
  
  return (
    <div className="border rounded-lg p-4 w-full">
      <h5 className="font-bold mb-2">{title}</h5>
      <div className="text-sm text-gray-700">
        <div>{address.name || `${address.firstName || ""} ${address.lastName || ""}`.trim()}</div>
        <div>{address.street1 || address.shippingStreet || ""}</div>
        {address.street2 || address.shippingLine2 ? (
          <div>{address.street2 || address.shippingLine2}</div>
        ) : null}
        <div>
          {(address.city || address.shippingCity || "")},{` `}
          {(address.state || address.shippingState || "")} {address.zip || address.shippingPostal || ""}
        </div>
        <div>{address.country || address.shippingCountry || "US"}</div>
      </div>
    </div>
  );
};

export default function ValidatedAddressModal({ show, ...props }) {
  const [useValidated, setUseValidated] = useState(true);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      role="dialog"
      aria-modal="true"
      aria-label="Validated Address Options"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-3xl w-full p-6">
        <h4 className="text-xl font-bold mb-4 text-center">Address Validation</h4>
        <p className="text-gray-600 mb-6 text-center">
          We found a validated address. Choose which address to use for shipping.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="flex items-center mb-2">
              <input
                type="radio"
                name="addressSelection"
                className="mr-2"
                checked={useValidated}
                onChange={() => setUseValidated(true)}
              />
              <span className="font-semibold">Use Validated Address (recommended)</span>
            </label>
            <AddressBlock title="Validated Address" address={props.recommendedAddress} />
          </div>

          <div>
            <label className="flex items-center mb-2">
              <input
                type="radio"
                name="addressSelection"
                className="mr-2"
                checked={!useValidated}
                onChange={() => setUseValidated(false)}
              />
              <span className="font-semibold">Use Given Address</span>
            </label>
            <AddressBlock title="Given Address" address={props.givenAddress} />
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            className="py-2 px-4 rounded-full font-bold bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button
            className="py-2 px-6 rounded-full font-bold bg-indigo-600 text-white hover:bg-indigo-700 transition"
            onClick={() => props.onContinue(useValidated ? "validated" : "given")}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}